import { DualAxes } from '@ant-design/charts'
import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const VisitTabDashboardStyled = styled.div`
    background-color: white;

    .legend-chart {
        width: 100%;
        margin-bottom: 20px;
    }
`

const Block = styled.span`
    width: 60px;
    height: 12px;
    margin-left: 15px;

    background: ${({ color }) => color || '#58AFFF'};

    display: inline-block;
`

export default function VisitTabDashboard({ getTypeLabel, dataVisits }) {
  const [trans] = useTranslation(['dashboard'])

  const [visits, setVisits] = useState([])
  const [visitsBounce, setVisitsBounce] = useState([])

  const config = {
    data: [visits, visitsBounce],
    xField: 'time',
    yField: ['value', 'value'],
    yAxis: {
      value: {
        tickCount: 10
      }
    },
    xAxis: {
      line: { style: {
        stroke: '#6d6d6d',
        shadowColor: '#6d6d6d'
      } }
    },
    height: 254,
    legend: false,
    tooltip: {
      formatter: (datum) => {
        if (datum.type === 'bounceRate') {
          return { name: 'Bounce Rate', value: `${datum.value.toFixed(2)}%` }
        }
        return { name: 'PV', value: `${datum.value}` }
      },
      customItems: (originalItems) => originalItems.filter((item) => item.name)
    },
    geometryOptions: [
      {
        geometry: 'column',
        seriesField: 'type',
        maxColumnWidth: 50,
        minColumnWidth: 10,
        color: ['#58AFFF'],
        label: {
          content: ''
        }
      },
      {
        geometry: 'line',
        color: 'red',
        seriesField: 'type',
        label: {
          content: ''
        }
      }
    ]
  }

  useEffect(() => {
    if (dataVisits) {
      const arrData = []
      const arrDataBounceRate = []
      if (dataVisits?.length > 0) {
        for (let i = 0; i < dataVisits?.length; i += 1) {
          const item = {
            value: dataVisits[i].activeUsers,
            type: 'activeUsers',
            time: getTypeLabel(dataVisits[i])
          }
          const itemBounceRate = {
            value: dataVisits[i].bounceRate * 100,
            type: 'bounceRate',
            time: getTypeLabel(dataVisits[i])
          }
          arrData.push(item)
          arrDataBounceRate.push(itemBounceRate)
        }
      }
      setVisits(arrData)
      setVisitsBounce(arrDataBounceRate)
    }
  }, [dataVisits])
  return (
    <VisitTabDashboardStyled>
      <Row>
        <Col sm={0} xl={4} />
        <Col sm={24} xl={16}>
          <div className="legend-chart">
            <span>PV</span> <Block />
            <span style={{ marginLeft: '40px' }}>{trans('dashboard:bounceRate')}</span> <Block color="red" />
          </div>
          <DualAxes {...config} />
        </Col>
        <Col sm={0} xl={4} />
      </Row>
    </VisitTabDashboardStyled>
  )
}

VisitTabDashboard.propTypes = {
  dataVisits: PropTypes.array,
  getTypeLabel: PropTypes.func
}
